module.exports = __webpack_public_path__ + "static/media/Corn11R6.1dc7700f.png";